import store from 'store/storeConfig';

export const hasRoleForGroup = (gid: string, role: UserRole, aid: string) => {
  const { groups } = store.getState();
  const admins: IAdmin[] = groups.groupAdmins.data || [];
  const admin = admins.find((admin) => admin.roles.some((r) => r.gid === gid) && admin.aid === aid);
  return admin?.roles.some((r) => r.roles.includes(role)) || false;
};

export const isOrganization = (group: IGroupInfo | IAccountGroup) => {
  return group.gid === 'all' || group.gid === group.parentGid;
};

export const getGroupsAdmins = (subgroupGids: string[]) => {
  const { groups } = store.getState();
  const groupAdmins = groups.groupAdmins.data.filter((admin: IAdmin) => {
    const adminRoles = admin.roles || [];
    const adminGroups = adminRoles.map((role) => role.gid);
    return subgroupGids.some((gid) => adminGroups.includes(gid));
  });
  return groupAdmins;
};

export const formatAssigneesNames = (assignees: string[]) => {
  const { groups } = store.getState();
  const admins = groups.groupAdmins.data;
  return assignees
    .map((aid) => {
      const admin = admins.find((a: IAdmin) => a.aid === aid);
      return admin ? admin.name : '';
    })
    .join(', ');
};
